// extracted by mini-css-extract-plugin
export var label = "_9g-1";
export var reminder = "_9g-0";